import React from 'react';
import { RouteContext } from '../../context';
import { useRouteAccess, RouteAccessChecks } from '../../routes/routeAccess';
import { PageContent } from '../UI';

export interface PageLayoutProps {
  routeAccessCheck?: keyof RouteAccessChecks;
  noToolbar?: boolean;
  fullpage?: boolean;
  noSpace?: boolean;
}

export const PageLayout: React.FC<PageLayoutProps> = ({
  routeAccessCheck,
  children,
  noToolbar = false,
  fullpage = false,
  noSpace = false,
}) => {
  const routeAccess = useRouteAccess();
  const { pathname } = React.useContext(RouteContext);
  const isSettingsPage = pathname.startsWith('/settings');
  return (
    <PageContent
      allowed={routeAccess[routeAccessCheck]}
      noToolbar={noToolbar}
      fullPage={fullpage}
      noSpace={noSpace}
      isSettingsPage={isSettingsPage}
    >
      {children}
    </PageContent>
  );
};
